import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import { useUpdateClientMutation } from "store/features/client/clientManagementApi";

const EditClientModal = ({ isOpen, toggle, client, onClientUpdate }) => {
  const [updateClient, { isLoading }] = useUpdateClientMutation();

  const handleSubmit = async (data) => {
    try {
      await updateClient({ id: client.id, ...data }).unwrap();
      onClientUpdate();
    } catch (error) {
      console.error('Client update error:', error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Edit Client - {client.company_name}</ModalHeader>
      <QwikForm onSubmit={handleSubmit} defaultValues={client}>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="client_name"
                  label="Client Name"
                  placeholder="Enter client name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="company_name"
                  label="Company Name"
                  placeholder="Enter company name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="client_email"
                  label="Email Address"
                  placeholder="Enter email address"
                  type="email"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikSelect
                  name="gender"
                  label="Gender"
                  options={[
                    { value: "male", label: "Male" },
                    { value: "female", label: "Female" },
                    { value: "other", label: "Other" }
                  ]}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="contact_person"
                  label="Contact Person"
                  placeholder="Enter contact person name"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="contact_number"
                  label="Contact Number"
                  placeholder="Enter contact number"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="company_website"
                  label="Company Website"
                  placeholder="Enter company website"
                  type="url"
                  className="form-control"
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="address"
                  label="Address"
                  placeholder="Enter full address"
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="notes"
                  label="Notes"
                  placeholder="Enter any additional notes"
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Client"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default EditClientModal;